export const SurfboardIcon = ({ className = '' }: { className?: string }) => (
  <svg
    fill="currentColor"
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 485.001 485.001"
    className={className}
  >
    <path
      d="M484.939,14.403l-0.591-13.75l-13.75-0.592c-0.235-0.01-1.521-0.061-3.801-0.061c-26.749,0-166.813,6.632-297.751,137.572
	c-43.735,43.735-86.461,97.251-117.222,146.827C27.18,324.114-1.799,380.627,0.087,424.32l0.251,5.832l54.508,54.508l5.832,0.251
	c1.361,0.059,2.762,0.089,4.162,0.089c74.54,0,198.581-85.041,282.586-169.046c74.38-74.379,107.794-151.972,122.728-203.967
	C486.473,55.169,485.009,16.041,484.939,14.403z M77.315,300.216c29.6-47.704,70.766-99.253,112.943-141.431
	c52.197-52.197,111.799-89.49,177.15-110.844c24.769-8.093,46.472-12.554,63.442-15.005L38.2,425.587l-8.153-8.153
	C31.055,389.281,47.656,348.014,77.315,300.216z M326.214,294.741c-41.351,41.35-91.987,81.947-138.927,111.381
	c-48.7,30.539-91.037,47.784-119.724,48.828l-8.151-8.151L451.994,54.218C444.406,106.252,417.906,203.049,326.214,294.741z"
    />
  </svg>
)
